import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import "./../bindings/bao-searcher";
function MandatorCopyWizardViewModel(tabPage) {
    var self = this;
    self.Bao = Bao;
    self.IsLoading = ko.observable();
    self.SourceMandatorId = ko.observable();
    self.SourceMandatorName = ko.observable();
    self.UseMandator = ko.observable("NewMandator");
    self.UseCurrentMandator = ko.observable(false);
    self.NewMandatorName = ko.observable();
    self.NewMandatorNumber = ko.observable();
    self.UseMandator.subscribe(function (value) {
        if (value = "NewMandator") {
            self.UseCurrentMandator(false);
        }
        else {
            self.UseCurrentMandator(true);
        }
    });
    self.AdminUserId = ko.observable();
    self.AdminUsername = ko.observable();
    self.AdminRoleId = ko.observable();
    self.AdminRoleName = ko.observable();
    self.CompleteCheck = function () {
        var returnValue = true;
        if (self.SourceMandatorId() == null) {
            returnValue = false;
        }
        if (self.UseCurrentMandator() == false && Bao.Utils.String.IsNullOrWhitespace(self.NewMandatorName()) && Bao.Utils.String.IsNullOrWhitespace(self.NewMandatorNumber())) {
            returnValue = false;
        }
        if (self.AdminUserId == null) {
            returnValue = false;
        }
        if (self.AdminRoleId == null) {
            returnValue = false;
        }
        if (returnValue == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return returnValue;
    };
    self.CopyMandator = function () {
        if (self.CompleteCheck() == true) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("CopyMandator"), "question");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result == true) {
                    tabPage.IsLoading(true);
                    Bao.post("Mandator/CopyMandator", JSON.stringify({
                        sourceMandatorId: self.SourceMandatorId(),
                        useCurrentMandator: self.UseCurrentMandator(),
                        mandatorName: self.NewMandatorName(),
                        mandatorNumber: self.NewMandatorNumber(),
                        userId: self.AdminUserId(),
                        roleId: self.AdminRoleId()
                    }), function (value) {
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgMandatorCopyComplete"), "info");
                        self.SourceMandatorId(null);
                        self.SourceMandatorName("");
                        self.UseMandator("NewMandator");
                        self.UseCurrentMandator(false);
                        self.NewMandatorName("");
                        self.NewMandatorNumber("");
                        self.AdminUserId(null);
                        self.AdminUsername("");
                        self.AdminRoleId(null);
                        self.AdminRoleName("");
                        tabPage.IsLoading(false);
                    });
                }
            });
        }
    };
}
export default MandatorCopyWizardViewModel;